<template>
  <div class="home">
    <EventList />
    <MeetingDetails ></MeetingDetails>
    <router-view v-if="$store.state.showMeetingDetails"></router-view>
  </div>
</template>

<script>

/* eslint-disable no-debugger */
import Navigation from "@/components/Navigation";
import EventList from "@/components/organisms/EventList";
import TimeZone from "@/components/TimeZonePicker.vue";
import MeetingDetails from "@/components/meeting/MeetingDetails";
import {mapGetters, mapMutations} from "vuex";
import Moment from "moment";

export default {
  name: "Meetings",
  components: {
    Navigation,
    EventList,
    MeetingDetails
  },
  methods: {
    ...mapMutations([
      "setShowMeetingDetails",
      "toggleModal",
      "setTimeZone"
    ]),
    currentTimezone() {
      var zone =  Moment.tz.guess();
      this.setTimeZone(zone);
      return zone;
    },
  },
  computed: mapGetters([ "showMeetingDetails"]),
  beforeMount() {
    this.currentTimezone();
    const sessionCheck = sessionStorage.getItem("userSignedIn");
    if (this.$store.state.signedInUser === false) {
      if (sessionCheck !== "true") {
        let data = decodeURIComponent(this.$route.query.data);
        data = encodeURIComponent(data);
        this.$router.push(`/signin?data=${data}`);
      }
    }
  },

};
</script>

<style lang="scss" scoped src="@/styles/style-home.scss">
</style>
